{
  "_comment": "[CI-LOCKED] O contido deste ficheiro está bloqueado. As contribucións son benvidas, pero a validación da modificación pode demorarse.",
  "ACCESS_KEY_ALT": "ALT MAIÚS $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Opción $1",
  "ACTIVITY_BOT_SAID_ALT": "O bot $1 dixo:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Axente",
  "ACTIVITY_YOU_SAID_ALT": "Dixo:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Anexado ao bot:",
  "ACTIVITY_CODE_ALT": "Código de exemplo: $1",
  "ACTIVITY_CONTENT_CAUTION": "O contido xerado mediante IA pode ser incorrecto",
  "ACTIVITY_CODE_CAUTION": "Código xerado mediante IA. Revíseo e úseo con coidado",
  "ACTIVITY_ERROR_BOX_TITLE": "Mensaxe de erro",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Prema para interactuar.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "A mensaxe é interactiva.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Unha ou varias ligazóns na mensaxe.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Erro ao enviar.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Anexou:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "Un anexo.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 anexos.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 anexos.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Erro no envío. [Tentar de novo][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Enviando",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Enviada ás $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Agora mesmo",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Hai unha hora",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Hai un minuto",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Hoxe",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Onte",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Erro de análise do cartón adaptable",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Erro de procesamento do cartón adaptable",
  "ATTACHMENT_AUDIO": "Un clip de audio.",
  "ATTACHMENT_CARD": "Un cartón: $1 $2 $3",
  "ATTACHMENT_FILE": "Un ficheiro: $1",
  "ATTACHMENT_IMAGE": "Unha imaxe",
  "ATTACHMENT_TEXT": "Un texto: $1",
  "ATTACHMENT_VIDEO": "Un clip de vídeo",
  "AVATAR_ALT": "Avatar de $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Seguinte",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Anterior",
  "CITATION_MODEL_DIALOG_ALT": "Cita",
  "CLOSE_BUTTON_ALT": "Pechar",
  "COLLAPSIBLE_GROUPING_TITLE": "Pensando…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Isto móstrase cando o bot compón mensaxes de resposta nun grupo se non se proporciona ningún resumo.",
  "COLLAPSE_BUTTON_LESS": "Mostrar menos",
  "COLLAPSE_BUTTON_LESS.comment": "Este é o texto dun botón de comiñas angulares para contraer o grupo de mensaxes. Cando o usuario final fai clic no botón, o grupo de mensaxes contráese.",
  "COLLAPSE_BUTTON_MORE": "Mostrar máis",
  "COLLAPSE_BUTTON_MORE.comment": "Este é o texto dun botón de comiñas angulares para ampliar o grupo de mensaxes. Cando o usuario final fai clic no botón, o grupo de mensaxes amplíase.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Conectado",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Conectando…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Non é posible conectarse.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Produciuse unha interrupción da rede. Conectando de novo…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Erro de procesamento. Comprobe a consola ou póñase en contacto co programador do bot.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "A conexión está a tardar máis do normal.",
  "CONNECTIVITY_STATUS_ALT": "Estado da conectividade: $1",
  "COPY_BUTTON_TEXT": "Copiar",
  "COPY_BUTTON_COPIED_TEXT": "Copiado",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Enviar",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Cancelar",
  "FEEDBACK_FORM_PLACEHOLDER": "Forneza todos os detalles posibles, pero non inclúa ningunha información privada nin confidencial.",
  "FEEDBACK_FORM_TITLE": "Cóntenos a súa experiencia",
  "FILE_CONTENT_ALT": "\"$1\"",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Descargar o ficheiro \"$1\"",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Descargar o ficheiro \"$1\" cun tamaño de $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "\"$1\" cun tamaño de $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Ábrese nunha ventá nova; externa.",
  "RECEIPT_CARD_TAX": "Imposto",
  "RECEIPT_CARD_TOTAL": "Total",
  "RECEIPT_CARD_VAT": "IVE",
  "REFERENCE_LIST_HEADER_ONE": "Referencia de $1",
  "REFERENCE_LIST_HEADER_FEW": "Referencias de $1",
  "REFERENCE_LIST_HEADER_MANY": "Referencias de $1",
  "REFERENCE_LIST_HEADER_OTHER": "Referencias de $1",
  "REFERENCE_LIST_HEADER_TWO": "Referencias de $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Eliminar anexo $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Eliminar",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Un ficheiro",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Unha imaxe",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Non se pode enviar unha mensaxe baleira.",
  "SPEECH_INPUT_LISTENING": "Escoitando…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Apagar Micrófono",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Acender micrófono",
  "SPEECH_INPUT_STARTING": "Iniciando…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Seguinte",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Anterior",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Accións suxeridas",
  "TEXT_INPUT_ALT": "Caixa de entrada de mensaxes",
  "TEXT_INPUT_PLACEHOLDER": "Escriba a mensaxe",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Comeza a falar...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Escoitando...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Procesando...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Fala para interromper...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Enviar",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Falar",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Cargar ficheiro",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Teclado telefónico",
  "TEXT_INPUT_DROP_ZONE": "Soltar ficheiros",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Superouse a lonxitude da mensaxe",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Só admite entrada dun só díxito",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 anexo",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 anexos",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 anexos",
  "TOAST_ACCORDION_FEW": "$1 notificacións: prema aquí para ver os detalles",
  "TOAST_ACCORDION_MANY": "$1 notificacións: prema aquí para ver os detalles",
  "TOAST_ACCORDION_OTHER": "$1 notificacións: prema aquí para ver os detalles",
  "TOAST_ACCORDION_TWO": "$1 notificacións: prema aquí para ver os detalles",
  "TOAST_ALT_ERROR": "Erro",
  "TOAST_ALT_INFO": "Información",
  "TOAST_ALT_SUCCESS": "Correcto",
  "TOAST_ALT_WARN": "Aviso",
  "TOAST_DISMISS_BUTTON": "Rexeitar",
  "TOAST_TITLE_ALT": "Notificación",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Historial de chat, prema as teclas de frecha para navegar.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "historial de chat",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "A mensaxe é interactiva. Prema as teclas MAIÚS e TAB dúas ou tres veces para cambiar ao historial de chat. A continuación, prema na mensaxe para interactuar.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Unha ou varias ligazóns da mensaxe. Prema as teclas MAIÚS e TAB dúas ou tres veces para cambiar ao historial de chat. A continuación, prema na mensaxe para interactuar.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "A mensaxe ten accións suxeridas. Prema MAIÚS e TAB dúas ou tres veces para seleccionalas.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "A mensaxe ten accións suxeridas. Prema $1 para seleccionalas.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Non foi posible enviar a mensaxe.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Novas mensaxes dispoñibles. Prema $1 para enfocar o botón \"$2\".",
  "TRANSCRIPT_MORE_MESSAGES": "Máis mensaxes",
  "TRANSCRIPT_NEW_MESSAGES": "Mensaxes novas",
  "TRANSCRIPT_TERMINATOR_TEXT": "Fin do historial de chat",
  "TYPING_INDICATOR_ALT": "Mostrando o indicador de escritura",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 está a escribir.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 e outras persoas están a escribir.",
  "VIEW_CODE_BUTTON_TEXT": "Código",
  "VOTE_COMPLETE_ALT": "Comentarios rexistrados",
  "VOTE_COMPLETE_ALT.comment": "Isto é para o lector de pantalla. Etiqueta dun botón con iconas de polgares cara a arriba e cara a abaixo. A etiqueta úsase cando se rexistran comentarios.",
  "VOTE_DISLIKE_ALT": "Non me gusta",
  "VOTE_LIKE_ALT": "Gústame"
}